module.exports = __webpack_public_path__ + "static/img/core-item-2.d2e5475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCodePhone/core-item-2.png
// module id = LzMr
// module chunks = 0